import React from "react";
import { useSelector } from "react-redux";
import Box from "components/common/Box";
import StockTicker from "components/common/StockTicker";
import AllInOneTopNav from "components/allInOneDashboard/AllInOneTopNav";
import AllInOneBottomNav from "components/allInOneDashboard/AllInOneBottomNav";
import AllInOnePageTransition from "components/allInOneDashboard/AllInOnePageTransition";
import SupportFab from "components/allInOneDashboard/SupportFab";
import { MOBILE_CONTENT_PB } from "components/allInOneDashboard/constants/mobileTheme";
import {
  NATIVE_STICKY_TICKER_SX,
  STICKY_TICKER_SX,
  TICKER_HEIGHT,
} from "components/allInOneDashboard/constants/navTheme";
import { config } from "config";

const AllInOneLayout = ({ children }) => {
  const isNativeApp = config.isMobileApp;
  console.log("isNativeApp", isNativeApp);
  const isProfileNavEnabled = useSelector(
    (state) =>
      !!(
        state.onboarding.isOnboardingCompleted ||
        state.jarvisRMS.rmsOnboarding.isOnboardingCompleted ||
        state.jarvisOnestock.onestockOnboarding.isOnboardingCompleted ||
        state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted ||
        state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted ||
        state.PHC.PHCOnboarding.isOnboardingCompleted
      ),
  );

  return (
    <Box sx={{ bgcolor: "#fff", minHeight: "100vh" }}>
      <AllInOneTopNav isProfileDisabled={!isProfileNavEnabled} />

      {/* Mobile: stick ticker flush under navbar; desktop: normal flow */}
      <Box sx={isNativeApp ? NATIVE_STICKY_TICKER_SX : STICKY_TICKER_SX}>
        <StockTicker />
      </Box>
      {/* Native fixed ticker needs a spacer so content isn't covered */}
      {/* {isNativeApp ? (
        <Box
          aria-hidden
          sx={{
            bgcolor: "red",
            height: TICKER_HEIGHT,
            flexShrink: 0,
          }}
        />
      ) : null} */}

      <Box
        sx={{
          // bgcolor: "green",
          // Clear fixed bottom nav only on native; keep content flush under ticker.
          pb: isNativeApp
            ? {
                xs: MOBILE_CONTENT_PB,
                md: MOBILE_CONTENT_PB,
              }
            : {
                xs: "0px",
                md: 0,
              },
        }}
      >
        <AllInOnePageTransition>{children}</AllInOnePageTransition>
      </Box>
      <SupportFab />
      <AllInOneBottomNav />
    </Box>
  );
};

export default AllInOneLayout;
